import React from "react";
import { Typography } from "@mui/material";
import { getPageTitle } from "../../common/CommonFunctions";

const PageHeader = ({ headerClass, typhoClass, variant, title }) => {
  const { pageName } = getPageTitle() || "";

  return (
    <div className={`mt-2 mb-3 ${headerClass}`}>
      <Typography
        className={`plus-jakarta-sans-semi-bold-600 ${typhoClass}`}
        variant={variant || "h5"}
      >
        {title ? title : pageName}
      </Typography>
    </div>
  );
};

export default PageHeader;
